import { fetchTicketsInAttendance, fetchTicketsInQueue } from 'components/DataBlock/services/tickets';
import { DEFAULT_PAGE_SIZE } from 'constants/utils';
import { Installation } from 'interfaces';
import { Dispatch, SetStateAction } from 'react';
import { ReportService } from 'services/Reports/ReportService';
import { TicketsResponse } from 'typings';
import { TableDataModel } from 'typings/components/TableDataModel';

export interface TicketFetchOptions {
    bots: Installation[];
    pageSize?: number;
    abortController?: AbortController;
}

export interface TicketFetchResult {
    data: TableDataModel<TicketsResponse['tickets']>;
    error?: string;
}

export class TicketService {
    private readonly reportService: ReportService;

    constructor(reportService: ReportService) {
        this.reportService = reportService;
    }

    private mapBotsToTranshipmentSkills(bots: Installation[]): string[] {
        return bots.map(bot => bot.transhipmentSkill);
    }

    async fetchTicketsInAttendance(
        options: TicketFetchOptions,
        setLoading: Dispatch<SetStateAction<boolean>>,
        setData: Dispatch<SetStateAction<TableDataModel<TicketsResponse['tickets']>>>,
    ): Promise<void> {
        if (!options.bots.length) return;

        const transhipmentSkills = this.mapBotsToTranshipmentSkills(options.bots);
        const pageSize = options.pageSize || DEFAULT_PAGE_SIZE;

        await fetchTicketsInAttendance(
            this.reportService,
            transhipmentSkills,
            pageSize,
            setLoading,
            setData,
            options.abortController,
        );
    }

    async fetchTicketsInQueue(
        options: TicketFetchOptions,
        setLoading: Dispatch<SetStateAction<boolean>>,
        setData: Dispatch<SetStateAction<TableDataModel<TicketsResponse['tickets']>>>,
    ): Promise<void> {
        if (!options.bots.length) return;

        const transhipmentSkills = this.mapBotsToTranshipmentSkills(options.bots);
        const pageSize = options.pageSize || DEFAULT_PAGE_SIZE;

        await fetchTicketsInQueue(
            this.reportService,
            transhipmentSkills,
            pageSize,
            setLoading,
            setData,
            options.abortController,
        );
    }

    async fetchAllTickets(
        options: TicketFetchOptions,
        setLoadingAttendance: Dispatch<SetStateAction<boolean>>,
        setDataAttendance: Dispatch<SetStateAction<TableDataModel<TicketsResponse['tickets']>>>,
        setLoadingQueue: Dispatch<SetStateAction<boolean>>,
        setDataQueue: Dispatch<SetStateAction<TableDataModel<TicketsResponse['tickets']>>>,
    ): Promise<void> {
        if (!options.bots.length) return;

        await Promise.all([
            this.fetchTicketsInAttendance(options, setLoadingAttendance, setDataAttendance),
            this.fetchTicketsInQueue(options, setLoadingQueue, setDataQueue),
        ]);
    }

    canFetchTickets(bots: Installation[]): boolean {
        return bots.length > 0;
    }

    getTranshipmentSkills(bots: Installation[]): string[] {
        return this.mapBotsToTranshipmentSkills(bots);
    }
}
